import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatText(text: string) {
    if (!text) return text;
    // Replace space after single letter conjunctions (a, i, o, u, w, z) with non-breaking space
    return text.replace(/(\s|^)([aiouwzAIOUWZ])\s+/g, '$1$2\u00A0');
}
